import { IUserManagement } from "@types"
import { protectedApi } from "store/Api"

const settingsUserManagement = protectedApi.injectEndpoints({


    endpoints: (builder) => ({
        settingsUserManagement: builder.query<IUserManagement[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `settings/user_management`,
                }
            },
        }),
    }),
})

export const { useSettingsUserManagementQuery } = settingsUserManagement
